import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
   * Logger Factory
   * ES:
   * @namespace disabled: if true the toggle is disable
   * @namespace onChecked: is the value brought to his parent
   *  <ute-toggle disabled="true" (onChecked)="test($event)"></ute-toggle>
*/

@Component({
  selector: 'ute-toggle',
  templateUrl: 'ute-toggle.component.html'
})
export class UteToggleComponent  {
  @Input() disabled: boolean;
  @Input() checked: boolean;
  @Output() onChecked = new EventEmitter;

  constructor() {}

  onChangeToggle(event){
   this.onChecked.emit(event.checked);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-toggle/ute-toggle.component.ts